import { keyBy } from 'lodash';
import { FieldSection, FieldSectionType } from 'api/field-sections/types';
import { RbacPermissionRule } from 'api/rbac/rbac-types';
import { Field } from 'api/tasks';
import { FieldSectionMapping } from './section-list';

export const computeSectionFieldMapping = (
  fieldList: Field[],
  fieldSections: FieldSection[] | undefined,
): FieldSectionMapping[] => {
  const fieldMap = keyBy(fieldList, 'fieldId');

  if (!fieldSections) {
    return [];
  }

  return fieldSections.map((section) => {
    const fieldsList: Field[] = [];

    if (section.fieldOrder) {
      section.fieldOrder.forEach((fieldId) => {
        if (fieldMap[fieldId]) {
          fieldsList.push(fieldMap[fieldId]);
        }
      });
    }

    return {
      ...section,
      fieldOrder: fieldsList,
    };
  });
};

export const filterSectionsBySearch = (
  searchText: string,
  fieldSectionMapping: FieldSectionMapping[],
) => {
  if (!searchText) {
    return fieldSectionMapping;
  }

  return fieldSectionMapping.map(({ fieldOrder: fields, ...rest }) => {
    return {
      ...rest,
      fieldOrder: fields.filter(({ fieldLabel, fieldName }) =>
        (fieldLabel ?? fieldName)
          ?.toLowerCase()
          .includes(searchText.toLowerCase()),
      ),
    };
  });
};

export const getEditRuleForSection = (
  sectionType: FieldSectionType,
): RbacPermissionRule | undefined => {
  switch (sectionType) {
    case FieldSectionType.Project:
      return 'PROJECT_GROUP_FIELD_SECTION:WRITE';
    case FieldSectionType.Task:
      return 'TASK_GROUP_FIELD_SECTION:WRITE';
    case FieldSectionType.Users:
      return 'SETTINGS_TEAM_MEMBER_FIELD:WRITE';
    default:
      return undefined;
  }
};
export const getDeleteRuleForSection = (
  sectionType: FieldSectionType,
): RbacPermissionRule | undefined => {
  switch (sectionType) {
    case FieldSectionType.Project:
      return 'SETTINGS_PROJECT_FIELD:DELETE';
    case FieldSectionType.Task:
      return 'SETTINGS_TASK_FIELD:DELETE';
    case FieldSectionType.Users:
      return 'SETTINGS_TEAM_MEMBER_FIELD:DELETE';
    default:
      return undefined;
  }
};
